import { render, staticRenderFns } from "./DefaultToolbar.vue?vue&type=template&id=0b3f7327&scoped=true&"
import script from "./DefaultToolbar.vue?vue&type=script&lang=js&"
export * from "./DefaultToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultToolbar.vue?vue&type=style&index=0&id=0b3f7327&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f7327",
  null
  
)

export default component.exports